<template>
	<div :class="['c-app-header', { 'is-app': isApp === true }]">
		<!-- <div :class="['c-app-header__sidebar-button', { active: showSidebar === true }]">
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M4 6C4 4.89543 4.89543 4 6 4H18C19.1046 4 20 4.89543 20 6V18C20 19.1046 19.1046 20 18 20H6C4.89543 20 4 19.1046 4 18V6Z"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path d="M9 4V20" stroke="currentColor" stroke-width="2" />
        <path d="M15.5 10L13.5 12L15.5 14" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
      </svg>
    </div> -->
		<transition name="fade">
			<div class="c-app-header__inner" v-if="init">
				<transition name="fade-side">
					<Avatar v-if="appInit && isApp"></Avatar>
				</transition>
				<slot name="title" v-if="!isApp">
					<router-link to="/">
						<h1>Swipekit</h1>
					</router-link>
				</slot>
				<slot v-else>
					<div
						@click="onBoardClick"
						:class="[
							'c-app-header__sidebar-button',
							{ active: showSidebar === true },
						]"
					>
						<svg
							width="24"
							height="24"
							viewBox="0 0 24 24"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
						>
							<path
								d="M4 6C4 4.89543 4.89543 4 6 4H18C19.1046 4 20 4.89543 20 6V18C20 19.1046 19.1046 20 18 20H6C4.89543 20 4 19.1046 4 18V6Z"
								stroke="currentColor"
								stroke-width="1.5"
								stroke-linecap="round"
								stroke-linejoin="round"
							/>
							<path d="M9 4V20" stroke="currentColor" stroke-width="1.5" />
							<path
								d="M15.5 10L13.5 12L15.5 14"
								stroke="currentColor"
								stroke-width="1.5"
								stroke-linecap="round"
								stroke-linejoin="round"
							/>
						</svg>
					</div>
				</slot>

				<div class="c-app-header__buttons">
					<slot name="menu">
						<a
							:class="['btn', { active: showSidebar === true }]"
							@click.prevent="onBoardClick"
						>
							<svg
								width="24"
								height="24"
								viewBox="0 0 24 24"
								fill="none"
								xmlns="http://www.w3.org/2000/svg"
							>
								<path
									fill-rule="evenodd"
									clip-rule="evenodd"
									d="M23 11.25V18C23 19.6569 21.6569 21 20 21H4C2.34315 21 1 19.6569 1 18V11.25H23ZM23 9.75V8.25C23 6.59315 21.6569 5.25 20 5.25H11.6139C11.1522 5.25 10.7048 5.09027 10.3475 4.79791L8.70255 3.45209C8.34522 3.15973 7.89776 3 7.43607 3H4C2.34315 3 1 4.34315 1 6V9.75H23Z"
									fill="currentColor"
								/>
							</svg>

							Folders
						</a>

						<!-- <router-link :class="['btn', { active: $route.path.includes('brands') }]" to="/brands">
              <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" aria-hidden="true" role="img" x="256" y="256" class="iconify iconify--ion" viewBox="0 0 512 512">
                <path
                  fill="currentColor"
                  d="M483.13 245.38C461.92 149.49 430 98.31 382.65 84.33A107.13 107.13 0 0 0 352 80c-13.71 0-25.65 3.34-38.28 6.88C298.5 91.15 281.21 96 256 96s-42.51-4.84-57.76-9.11C185.6 83.34 173.67 80 160 80a115.74 115.74 0 0 0-31.73 4.32c-47.1 13.92-79 65.08-100.52 161C4.61 348.54 16 413.71 59.69 428.83a56.62 56.62 0 0 0 18.64 3.22c29.93 0 53.93-24.93 70.33-45.34c18.53-23.1 40.22-34.82 107.34-34.82c59.95 0 84.76 8.13 106.19 34.82c13.47 16.78 26.2 28.52 38.9 35.91c16.89 9.82 33.77 12 50.16 6.37c25.82-8.81 40.62-32.1 44-69.24c2.57-28.48-1.39-65.89-12.12-114.37ZM208 240h-32v32a16 16 0 0 1-32 0v-32h-32a16 16 0 0 1 0-32h32v-32a16 16 0 0 1 32 0v32h32a16 16 0 0 1 0 32Zm84 4a20 20 0 1 1 20-20a20 20 0 0 1-20 20Zm44 44a20 20 0 1 1 20-19.95A20 20 0 0 1 336 288Zm0-88a20 20 0 1 1 20-20a20 20 0 0 1-20 20Zm44 44a20 20 0 1 1 20-20a20 20 0 0 1-20 20Z"
                ></path>
              </svg>
              Brands
            </router-link> -->
						<router-link
							:class="['btn', { active: $route.name === 'Home' }]"
							to="/"
						>
							<svg
								viewBox="0 0 25 24"
								fill="none"
								xmlns="http://www.w3.org/2000/svg"
							>
								<path
									fill-rule="evenodd"
									clip-rule="evenodd"
									d="M22 17.6953V18C22 19.6569 20.6569 21 19 21H3C1.34315 21 0 19.6569 0 18V5C0 3.34315 1.34315 2 3 2H7.77736C8.12309 2 8.44429 2.17858 8.62675 2.47224L9.11001 3.25H21.0604C23.5375 3.25 25.3341 5.60924 24.6753 7.99723L22 17.6953ZM22 12.0547L23.2293 7.59834C23.6246 6.16555 22.5467 4.75 21.0604 4.75H10.042L10.8177 5.99835C11.0002 6.29201 11.3214 6.47059 11.6671 6.47059H19C20.6569 6.47059 22 7.81373 22 9.47059V12.0547Z"
									fill="currentColor"
								/>
							</svg>
							Library
						</router-link>
						<router-link
							:class="['btn', { active: $route.path.includes('multiplayer') }]"
							to="/multiplayer"
						>
							<svg
								xmlns="http://www.w3.org/2000/svg"
								xmlns:xlink="http://www.w3.org/1999/xlink"
								aria-hidden="true"
								role="img"
								x="256"
								y="256"
								class="iconify iconify--ion"
								viewBox="0 0 512 512"
							>
								<path
									fill="currentColor"
									d="M483.13 245.38C461.92 149.49 430 98.31 382.65 84.33A107.13 107.13 0 0 0 352 80c-13.71 0-25.65 3.34-38.28 6.88C298.5 91.15 281.21 96 256 96s-42.51-4.84-57.76-9.11C185.6 83.34 173.67 80 160 80a115.74 115.74 0 0 0-31.73 4.32c-47.1 13.92-79 65.08-100.52 161C4.61 348.54 16 413.71 59.69 428.83a56.62 56.62 0 0 0 18.64 3.22c29.93 0 53.93-24.93 70.33-45.34c18.53-23.1 40.22-34.82 107.34-34.82c59.95 0 84.76 8.13 106.19 34.82c13.47 16.78 26.2 28.52 38.9 35.91c16.89 9.82 33.77 12 50.16 6.37c25.82-8.81 40.62-32.1 44-69.24c2.57-28.48-1.39-65.89-12.12-114.37ZM208 240h-32v32a16 16 0 0 1-32 0v-32h-32a16 16 0 0 1 0-32h32v-32a16 16 0 0 1 32 0v32h32a16 16 0 0 1 0 32Zm84 4a20 20 0 1 1 20-20a20 20 0 0 1-20 20Zm44 44a20 20 0 1 1 20-19.95A20 20 0 0 1 336 288Zm0-88a20 20 0 1 1 20-20a20 20 0 0 1-20 20Zm44 44a20 20 0 1 1 20-20a20 20 0 0 1-20 20Z"
								></path>
							</svg>

							Multiplayer
						</router-link>
						<!-- <router-link :class="['btn', { active: $route.name === 'Home' }]" to="/">
              <svg viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M22 17.6953V18C22 19.6569 20.6569 21 19 21H3C1.34315 21 0 19.6569 0 18V5C0 3.34315 1.34315 2 3 2H7.77736C8.12309 2 8.44429 2.17858 8.62675 2.47224L9.11001 3.25H21.0604C23.5375 3.25 25.3341 5.60924 24.6753 7.99723L22 17.6953ZM22 12.0547L23.2293 7.59834C23.6246 6.16555 22.5467 4.75 21.0604 4.75H10.042L10.8177 5.99835C11.0002 6.29201 11.3214 6.47059 11.6671 6.47059H19C20.6569 6.47059 22 7.81373 22 9.47059V12.0547Z"
                  fill="currentColor"
                />
              </svg>
              Mixers
            </router-link> -->
					</slot>
				</div>

				<ExtensionStatus v-if="isApp"></ExtensionStatus>

				<!-- <span class="c-app-header__divider"></span> -->

				<a
					v-if="isApp"
					:class="['c-app-header__toggle', { active: showMenu === true }]"
					@click="toggleMenu"
					ref="menu"
				>
					<svg
						width="20"
						height="20"
						viewBox="0 0 24 24"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<path
							d="M3 6H21M3 12H21M3 18H21"
							stroke="currentColor"
							stroke-width="2"
							stroke-linecap="round"
						/>
					</svg>
				</a>
			</div>
		</transition>

		<!-- <transition name="fade">
      <div class="c-app-header__submenu" v-if="init">
        <a :class="['btn', { active: showSidebar === true }]" @click.prevent="onBoardClick"> Boards </a>
      </div>
    </transition> -->

		<Popup
			:offset="offset"
			v-if="popup"
			:target="menuTarget"
			:active="showMenu"
		>
			<transition>
				<div class="c-popup__inner">
					<slot name="links">
						<router-link to="/profile" v-if="user && user.avatar">
							<img
								:title="`${user.name}'s profile`"
								:src="`${assetUrl}/${user.avatar.name}`"
							/>
							<article>
								<p>{{ user.name }} {{ user.lastName }}</p>
								<span>
									{{ user.email }}
								</span>
							</article>
						</router-link>
						<h6>Links</h6>
						<ul>
							<li>
								<router-link to="/profile" class="btn">
									<svg
										width="24"
										height="24"
										viewBox="0 0 24 24"
										fill="none"
										xmlns="http://www.w3.org/2000/svg"
									>
										<path
											d="M4 18.8C4 16.149 6.14903 14 8.8 14H15.2C17.851 14 20 16.149 20 18.8V18.8C20 20.5673 18.5673 22 16.8 22H7.2C5.43269 22 4 20.5673 4 18.8V18.8Z"
											stroke="currentColor"
											stroke-width="1.5"
											stroke-linecap="round"
											stroke-linejoin="round"
										/>
										<path
											d="M16 6C16 8.20914 14.2091 10 12 10C9.79086 10 8 8.20914 8 6C8 3.79086 9.79086 2 12 2C14.2091 2 16 3.79086 16 6Z"
											stroke="currentColor"
											stroke-width="1.5"
											stroke-linecap="round"
											stroke-linejoin="round"
										/>
									</svg>
									Settings
								</router-link>
							</li>
							<li>
								<router-link to="/help" class="btn">
									<svg
										width="24"
										height="24"
										viewBox="0 0 24 24"
										fill="none"
										xmlns="http://www.w3.org/2000/svg"
									>
										<path
											d="M19.0711 4.92893L19.6014 4.3986L19.0711 4.92893ZM14.4697 8.46967C14.1768 8.76256 14.1768 9.23744 14.4697 9.53033C14.7626 9.82322 15.2374 9.82322 15.5303 9.53033L14.4697 8.46967ZM9.53033 15.5303C9.82322 15.2374 9.82322 14.7626 9.53033 14.4697C9.23744 14.1768 8.76256 14.1768 8.46967 14.4697L9.53033 15.5303ZM8.46967 9.53033C8.76256 9.82322 9.23744 9.82322 9.53033 9.53033C9.82322 9.23744 9.82322 8.76256 9.53033 8.46967L8.46967 9.53033ZM15.5303 14.4697C15.2374 14.1768 14.7626 14.1768 14.4697 14.4697C14.1768 14.7626 14.1768 15.2374 14.4697 15.5303L15.5303 14.4697ZM12 21.25C9.44548 21.25 7.134 20.2155 5.45926 18.5407L4.3986 19.6014C6.34315 21.5459 9.03168 22.75 12 22.75V21.25ZM5.45926 18.5407C3.78452 16.866 2.75 14.5545 2.75 12H1.25C1.25 14.9683 2.45406 17.6569 4.3986 19.6014L5.45926 18.5407ZM21.25 12C21.25 14.5545 20.2155 16.866 18.5407 18.5407L19.6014 19.6014C21.5459 17.6569 22.75 14.9683 22.75 12H21.25ZM18.5407 18.5407C16.866 20.2155 14.5545 21.25 12 21.25V22.75C14.9683 22.75 17.6569 21.5459 19.6014 19.6014L18.5407 18.5407ZM12 2.75C14.5545 2.75 16.866 3.78452 18.5407 5.45926L19.6014 4.3986C17.6569 2.45406 14.9683 1.25 12 1.25V2.75ZM18.5407 5.45926C20.2155 7.134 21.25 9.44548 21.25 12H22.75C22.75 9.03168 21.5459 6.34315 19.6014 4.3986L18.5407 5.45926ZM2.75 12C2.75 9.44548 3.78452 7.134 5.45926 5.45926L4.3986 4.3986C2.45406 6.34315 1.25 9.03168 1.25 12H2.75ZM5.45926 5.45926C7.134 3.78452 9.44548 2.75 12 2.75V1.25C9.03168 1.25 6.34315 2.45406 4.3986 4.3986L5.45926 5.45926ZM18.5407 4.3986L14.4697 8.46967L15.5303 9.53033L19.6014 5.45926L18.5407 4.3986ZM8.46967 14.4697L4.3986 18.5407L5.45926 19.6014L9.53033 15.5303L8.46967 14.4697ZM4.3986 5.45926L8.46967 9.53033L9.53033 8.46967L5.45926 4.3986L4.3986 5.45926ZM14.4697 15.5303L18.5407 19.6014L19.6014 18.5407L15.5303 14.4697L14.4697 15.5303ZM15.25 12C15.25 13.7949 13.7949 15.25 12 15.25V16.75C14.6234 16.75 16.75 14.6234 16.75 12H15.25ZM12 15.25C10.2051 15.25 8.75 13.7949 8.75 12H7.25C7.25 14.6234 9.37665 16.75 12 16.75V15.25ZM8.75 12C8.75 10.2051 10.2051 8.75 12 8.75V7.25C9.37665 7.25 7.25 9.37665 7.25 12H8.75ZM12 8.75C13.7949 8.75 15.25 10.2051 15.25 12H16.75C16.75 9.37665 14.6234 7.25 12 7.25V8.75Z"
											fill="currentColor"
										/>
									</svg>

									Help & Support
								</router-link>
							</li>
							<li>
								<a @click.prevent="onLogout" href="#" class="btn">
									<svg
										width="24"
										height="24"
										viewBox="0 0 24 24"
										fill="none"
										xmlns="http://www.w3.org/2000/svg"
									>
										<path
											d="M12 2V12M16 4.93555C18.9634 6.40825 21 9.46631 21 13C21 17.9706 16.9706 22 12 22C7.02944 22 3 17.9706 3 13C3 9.46631 5.03656 6.40825 8 4.93555"
											stroke="currentColor"
											stroke-width="1.5"
											stroke-linecap="round"
										/>
									</svg>
									Logout
								</a>
							</li>
						</ul>
						<h6>External Ad Libraries</h6>
						<ul>
							<li>
								<a
									class="btn"
									href="https://www.facebook.com/ads/library"
									target="_blank"
								>
									<svg
										width="24"
										height="24"
										viewBox="0 0 24 24"
										fill="none"
										xmlns="http://www.w3.org/2000/svg"
									>
										<path
											d="M17.7557 11.5739L18.1421 11.1876C19.6358 9.69387 19.6358 7.27214 18.1421 5.77846C16.6484 4.28478 14.2267 4.28478 12.733 5.77846L9.8316 8.67987C8.66003 9.85144 8.66003 11.7509 9.8316 12.9225L10.8012 13.8921M6.16483 12.3467L5.77846 12.7331C4.28478 14.2267 4.28478 16.6485 5.77846 18.1421C7.27214 19.6358 9.69387 19.6358 11.1876 18.1421L14.089 15.2407C15.2605 14.0692 15.2605 12.1697 14.089 10.9981L13.1194 10.0285"
											stroke="currentColor"
											stroke-linecap="round"
										/>
									</svg>

									Facebook Ad Library
								</a>
							</li>
							<li>
								<a class="btn" href="https://tiktok.com" target="_blank">
									<svg
										width="24"
										height="24"
										viewBox="0 0 24 24"
										fill="none"
										xmlns="http://www.w3.org/2000/svg"
									>
										<path
											d="M17.7557 11.5739L18.1421 11.1876C19.6358 9.69387 19.6358 7.27214 18.1421 5.77846C16.6484 4.28478 14.2267 4.28478 12.733 5.77846L9.8316 8.67987C8.66003 9.85144 8.66003 11.7509 9.8316 12.9225L10.8012 13.8921M6.16483 12.3467L5.77846 12.7331C4.28478 14.2267 4.28478 16.6485 5.77846 18.1421C7.27214 19.6358 9.69387 19.6358 11.1876 18.1421L14.089 15.2407C15.2605 14.0692 15.2605 12.1697 14.089 10.9981L13.1194 10.0285"
											stroke="currentColor"
											stroke-linecap="round"
										/>
									</svg>
									Tiktok.com
								</a>
							</li>
							<li>
								<a
									class="btn"
									href="https://ads.tiktok.com/business/creativecenter"
									target="_blank"
								>
									<svg
										width="24"
										height="24"
										viewBox="0 0 24 24"
										fill="none"
										xmlns="http://www.w3.org/2000/svg"
									>
										<path
											d="M17.7557 11.5739L18.1421 11.1876C19.6358 9.69387 19.6358 7.27214 18.1421 5.77846C16.6484 4.28478 14.2267 4.28478 12.733 5.77846L9.8316 8.67987C8.66003 9.85144 8.66003 11.7509 9.8316 12.9225L10.8012 13.8921M6.16483 12.3467L5.77846 12.7331C4.28478 14.2267 4.28478 16.6485 5.77846 18.1421C7.27214 19.6358 9.69387 19.6358 11.1876 18.1421L14.089 15.2407C15.2605 14.0692 15.2605 12.1697 14.089 10.9981L13.1194 10.0285"
											stroke="currentColor"
											stroke-linecap="round"
										/>
									</svg>
									Tiktok Creative Center
								</a>
							</li>
							<li>
								<a
									class="btn"
									href="https://library.tiktok.com/ads"
									target="_blank"
								>
									<svg
										width="24"
										height="24"
										viewBox="0 0 24 24"
										fill="none"
										xmlns="http://www.w3.org/2000/svg"
									>
										<path
											d="M17.7557 11.5739L18.1421 11.1876C19.6358 9.69387 19.6358 7.27214 18.1421 5.77846C16.6484 4.28478 14.2267 4.28478 12.733 5.77846L9.8316 8.67987C8.66003 9.85144 8.66003 11.7509 9.8316 12.9225L10.8012 13.8921M6.16483 12.3467L5.77846 12.7331C4.28478 14.2267 4.28478 16.6485 5.77846 18.1421C7.27214 19.6358 9.69387 19.6358 11.1876 18.1421L14.089 15.2407C15.2605 14.0692 15.2605 12.1697 14.089 10.9981L13.1194 10.0285"
											stroke="currentColor"
											stroke-linecap="round"
										/>
									</svg>
									Tiktok Ad Library(EU only)
								</a>
							</li>
							<li>
								<a
									class="btn"
									href="https://adstransparency.google.com"
									target="_blank"
								>
									<svg
										width="24"
										height="24"
										viewBox="0 0 24 24"
										fill="none"
										xmlns="http://www.w3.org/2000/svg"
									>
										<path
											d="M17.7557 11.5739L18.1421 11.1876C19.6358 9.69387 19.6358 7.27214 18.1421 5.77846C16.6484 4.28478 14.2267 4.28478 12.733 5.77846L9.8316 8.67987C8.66003 9.85144 8.66003 11.7509 9.8316 12.9225L10.8012 13.8921M6.16483 12.3467L5.77846 12.7331C4.28478 14.2267 4.28478 16.6485 5.77846 18.1421C7.27214 19.6358 9.69387 19.6358 11.1876 18.1421L14.089 15.2407C15.2605 14.0692 15.2605 12.1697 14.089 10.9981L13.1194 10.0285"
											stroke="currentColor"
											stroke-linecap="round"
										/>
									</svg>
									Google Ad Transparency page
								</a>
							</li>
							<li>
								<a
									class="btn"
									href="https://www.linkedin.com/ad-library/home"
									target="_blank"
								>
									<svg
										width="24"
										height="24"
										viewBox="0 0 24 24"
										fill="none"
										xmlns="http://www.w3.org/2000/svg"
									>
										<path
											d="M17.7557 11.5739L18.1421 11.1876C19.6358 9.69387 19.6358 7.27214 18.1421 5.77846C16.6484 4.28478 14.2267 4.28478 12.733 5.77846L9.8316 8.67987C8.66003 9.85144 8.66003 11.7509 9.8316 12.9225L10.8012 13.8921M6.16483 12.3467L5.77846 12.7331C4.28478 14.2267 4.28478 16.6485 5.77846 18.1421C7.27214 19.6358 9.69387 19.6358 11.1876 18.1421L14.089 15.2407C15.2605 14.0692 15.2605 12.1697 14.089 10.9981L13.1194 10.0285"
											stroke="currentColor"
											stroke-linecap="round"
										/>
									</svg>
									Linkedin Ad Library
								</a>
							</li>
							<li>
								<a
									class="btn"
									href="https://ads.pinterest.com/ads-repository"
									target="_blank"
								>
									<svg
										width="24"
										height="24"
										viewBox="0 0 24 24"
										fill="none"
										xmlns="http://www.w3.org/2000/svg"
									>
										<path
											d="M17.7557 11.5739L18.1421 11.1876C19.6358 9.69387 19.6358 7.27214 18.1421 5.77846C16.6484 4.28478 14.2267 4.28478 12.733 5.77846L9.8316 8.67987C8.66003 9.85144 8.66003 11.7509 9.8316 12.9225L10.8012 13.8921M6.16483 12.3467L5.77846 12.7331C4.28478 14.2267 4.28478 16.6485 5.77846 18.1421C7.27214 19.6358 9.69387 19.6358 11.1876 18.1421L14.089 15.2407C15.2605 14.0692 15.2605 12.1697 14.089 10.9981L13.1194 10.0285"
											stroke="currentColor"
											stroke-linecap="round"
										/>
									</svg>
									Pinterest Ad Library(EU only)
								</a>
							</li>
						</ul>
						<span class="small">
							You can save Ads from the above Ad Libraries via our Chrome
							extension.
						</span>
					</slot>
				</div>
			</transition>
		</Popup>
	</div>
</template>

<script>
import Popup from '@swipekit/components/popup';
import Avatar from './avatar';
import ExtensionStatus from './extension-status';

export default {
	components: {
		Avatar,
		Popup,
		ExtensionStatus,
	},

	data: function () {
		return {
			offset: [0, 32],
			init: false,
			popup: false,
			showMenu: false,
		};
	},

	watch: {
		$route: function () {
			this.showMenu = false;
		},
		appInit: function () {
			if (this.appInit && !this.init) {
				this.setInit();
			}
		},
	},

	props: {
		isApp: {
			type: Boolean,
			default: true,
		},
	},

	computed: {
		appInit: function () {
			return this.$store.getters['app/init'];
		},
		showSidebar: function () {
			return this.$store.getters['app/showSidebar'];
		},
		menuTarget: function () {
			return this.$refs.menu;
		},

		trialStartedDifference: function () {
			let diff = this.$store.getters['users/trialStartedDifference'];

			return diff;
		},
		isTrialOver: function () {
			return this.$store.getters['users/isTrialOver'];
		},
		user: function () {
			return this.$store.getters['users/user'];
		},
		boards: function () {
			return this.$store.getters['boards/filtered'];
		},
		computedBoards: function () {
			let boards = this.boards;

			for (let i = 0; i < boards.length; i++) {
				boards[i].blocks =
					this.$store.getters['ads/byBoard'](boards[i].id) || [];
			}

			return boards;
		},
		currentBoard: function () {
			if (!this.slug) {
				return { slug: null };
			}
			return this.$store.getters['boards/boardBySlug'](this.slug);
		},
		showSidebar: function () {
			return this.$store.getters['app/showSidebar'];
		},
		extensionState: function () {
			return this.$store.getters['extensionState'];
		},
		assetUrl: function () {
			return this.$store.getters['config/assetUrl'];
		},
	},

	methods: {
		onLogout: function () {
			this.showMenu = false;
			// add a small delay for ux purposes
			setTimeout(() => {
				this.$store.dispatch('users/logout');
			}, 50);
		},
		onBoardClick: function () {
			this.$store.dispatch('app/toggleSidebar');
		},
		toggleMenu: function () {
			this.$nextTick(() => {
				this.showMenu = !this.showMenu;
			});
		},

		onKeydown: function (e) {
			if (e.code === 'Escape') {
				this.showMenu = false;
			}
		},
		onMouseup: function (e) {
			if (e.target.closest('.c-popup')) {
				return;
			}
			if (e.target.closest('.c-app-header__toggle')) {
				return;
			}
			if (this.showMenu) {
				this.showMenu = false;
			}
		},
		setInit: function () {
			this.init = true;
			this.$nextTick(() => {
				this.popup = true;
			});
			this.addEventListeners();
		},
		addEventListeners: function () {
			window.addEventListener('keydown', this.onKeydown);
			window.addEventListener('mouseup', this.onMouseup);
		},
		removeEventListeners: function () {
			window.removeEventListener('keydown', this.onKeydown);
			window.removeEventListener('mouseup', this.onMouseup);
		},
	},

	mounted: function () {
		// this.$nextTick(() => {
		//  this.init = true;
		//  this.$nextTick(() => {
		//    this.popup = true;
		//  });
		// });
	},

	beforeDestroy: function () {
		this.removeEventListeners();
	},
};
</script>

<style lang="scss">
.c-app-header {
	position: fixed;
	z-index: 999;
	top: 0;
	left: 0;
	width: 100%;
	pointer-events: none;

	--height: 48px;
	--item-size: 32px;

	&.is-app {
		.c-app-header__buttons {
			right: auto;
			left: 50%;
			justify-content: center;
			transform: translateX(calc(-50% + 12px));
		}

		.c-app-header__toggle {
			margin-left: initial;
		}
	}

	&__sidebar-button {
		display: flex;
		justify-content: center;
		align-items: center;
		margin-left: var(--margin);
		color: #fff;
		cursor: pointer;

		&.active {
			opacity: 0.8;
		}
	}

	&__inner {
		display: flex;
		align-items: center;
		position: relative;
		z-index: 999;
		margin: 0 auto;
		margin-top: var(--margin-lg);
		width: calc(var(--header-width) + 0px);
		height: var(--height);
		background-color: var(--color-bg-99);
		border-radius: 99px;
		pointer-events: all;

		box-shadow: 0 0 8px 1px hsla(var(--p), 15%, 30%, 0.1),
			0 4px 12px 1px hsla(var(--p), 15%, 30%, 0.3);
	}

	&__submenu {
		display: flex;
		align-items: center;
		position: relative;
		z-index: 998;
		margin: 0 auto;
		margin-top: 0;
		width: 300px;
		height: 32px;
		padding: var(--margin-sm);
		background-color: var(--color-bg-1);
		border-bottom-left-radius: 10px;
		border-bottom-right-radius: 10px;
		pointer-events: all;

		box-shadow: 0 0 8px 1px hsla(var(--p), 15%, 30%, 0.05),
			0 4px 12px 1px hsla(var(--p), 15%, 30%, 0.15);
	}

	.btn {
		display: inline-flex;
		align-items: center;
		justify-content: center;
		padding: var(--margin);
		margin-right: var(--margin);
		background-color: rgba(255, 255, 255, 0);
		border-radius: 5px;
		font-size: var(--font-size-sm);
		color: #ededed;
		line-height: 1;

		svg {
			width: 18px;
			height: 18px;
			margin-right: var(--margin);
			color: #fff;
		}

		&:hover,
		&:active,
		&.active {
			box-shadow: none !important;
			background-color: var(--color-primary) !important;
			color: #fff;
		}

		&:focus {
			box-shadow: none !important;
		}
	}

	&__buttons {
		position: absolute;
		top: 0;
		right: 12px;
		width: 75%;
		height: 100%;
		//transform: translateX(calc(-50% - 12px));
		display: flex;
		justify-content: flex-end;
		align-items: center;
		//margin-left: auto;
		//margin-right: 8px;
	}

	&__divider {
		display: inline-block;
		width: 1px;
		height: 24px;
		margin-right: calc(8px + var(--margin));
		background-color: rgba(255, 255, 255, 0.3);
	}

	.c-header-extension-status {
		margin-left: auto;
	}

	&__toggle {
		margin-left: auto;
		display: inline-flex;
		align-items: center;
		justify-content: center;
		width: var(--item-size);
		height: var(--item-size);
		margin-right: 8px;
		background-color: transparent;
		border-radius: 99px;

		text-decoration: none !important;

		color: #fff;

		user-select: none;

		cursor: pointer;

		transition: all 120ms linear;

		svg {
			width: 20px;
			height: 20px;
		}

		&.active {
			background-color: #fff;
			color: #000;
		}
	}

	h1 {
		margin: 0;
		margin-left: 8px;
		font-size: 16px;
		font-weight: 450;
		line-height: 1;
		color: #fff;
	}

	.c-popup {
		background: transparent;
		pointer-events: none;
		box-shadow: none;
		width: 280px;

		&__arrow {
			//display: none;
			color: var(--color-bg-99);
		}

		&__inner {
			pointer-events: none;
			background: var(--color-bg-99);
			border-radius: var(--border-radius-lg);
			box-shadow: var(--box-shadow);

			> a {
				display: grid;
				grid-template-columns: 32px 1fr;
				align-items: center;
				padding: 0 var(--margin-lg);
				padding-top: var(--margin);
				color: #ededed;
				text-decoration: none !important;

				img {
					width: 32px;
					height: 32px;
					border-radius: 99px;
					object-fit: cover;
					object-position: center center;
				}

				> article {
					padding: var(--margin);

					p {
						margin: 0;
						line-height: 1.3;
					}

					span {
						display: block;
						padding: 0;
						line-height: 1.1;
					}
				}
			}

			span {
				display: inline-block;
				padding: var(--spacer-sm);
				padding-top: var(--margin);
				font-size: var(--font-size-xs);
				color: #ededed;
				opacity: 0.6;
			}
		}

		h6 {
			color: #c5c5c5;
			padding: var(--margin-lg) 16px 0 16px;
			margin: 0;
		}

		ul {
			width: 100%;
			display: inline-block;
			margin: 0;
			padding: 0;
			list-style: none;

			li {
				margin: var(--margin);

				.btn {
					width: 100%;
					justify-content: flex-start;
					padding: var(--margin-lg);
				}
			}
		}

		&.active {
			.c-popup__inner {
				pointer-events: all;
			}
		}
	}

	.v-enter-active,
	.v-leave-active {
		transition: all 120ms cubic-bezier(0.55, 0.055, 0.675, 0.19);
	}

	.v-enter, .v-leave-to /* .fade-leave-active below version 2.1.8 */ {
		opacity: 0;
	}

	.fade-enter-active,
	.fade-leave-active {
		transition: all 750ms cubic-bezier(0.215, 0.61, 0.355, 1);
	}
	.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
		transform: translateY(-10px);
		opacity: 0;
	}

	.fade-side-enter-active,
	.fade-side-leave-active {
		transition: all 500ms cubic-bezier(0.215, 0.61, 0.355, 1);
	}
	.fade-side-enter, .fade-side-leave-to /* .fade-leave-active below version 2.1.8 */ {
		transform: translateX(-4px);
		opacity: 0;
	}

	.show-sm {
		display: none;
	}

	@media (max-width: 768px) {
		.show-sm {
			display: block;
		}
		.hide-sm {
			display: none;
		}
		&__inner {
			margin-top: 0;
			border-radius: 0;
		}

		&__divider {
			display: none;
		}

		&__toggle {
		}
	}

	@media (max-width: 576px) {
		.c-header-extension-status {
			display: none;
		}

		&__toggle {
			margin-left: auto !important;
		}

		&__buttons {
			svg {
				display: none;
			}
		}
	}
}
</style>
